export var FirmwareGatewayModel;
(function (FirmwareGatewayModel) {
    FirmwareGatewayModel["ENERGYBOX_HUB"] = "ENERGYBOX_HUB";
    FirmwareGatewayModel["GHUB"] = "GHUB";
    FirmwareGatewayModel["ENERGYBOX_CB"] = "ENERGYBOX_CB";
    FirmwareGatewayModel["ENERGYPRO"] = "ENERGYPRO";
    FirmwareGatewayModel["ENERGYPRO2"] = "ENERGYPRO2";
    FirmwareGatewayModel["VENSTAR_THERMOSTAT"] = "VENSTAR_THERMOSTAT";
})(FirmwareGatewayModel || (FirmwareGatewayModel = {}));
export var ReleaseTypeHumanReadable;
(function (ReleaseTypeHumanReadable) {
    ReleaseTypeHumanReadable["BETA"] = "Beta";
    ReleaseTypeHumanReadable["RELEASE"] = "Release";
    ReleaseTypeHumanReadable["EXPERIMENTAL"] = "Experimental";
})(ReleaseTypeHumanReadable || (ReleaseTypeHumanReadable = {}));
export var FirmwareTag;
(function (FirmwareTag) {
    FirmwareTag["release"] = "Release";
    FirmwareTag["intermittent"] = "Intermittent";
})(FirmwareTag || (FirmwareTag = {}));
